import { createContext } from 'react';

interface TopbarContextValue {
  isTransparentTopbar: boolean;
  isFullBleedTopbar: boolean;
}

const TopbarTransparencyContext = createContext<TopbarContextValue>({
  isTransparentTopbar: false,
  isFullBleedTopbar: false,
});

export default TopbarTransparencyContext;
